export default __webpack_public_path__ + "static/media/arrowRightShadow.a23f8086.svg";